export const REGS = {
  ALL: 1,
  DEVICE_ID: 0x0010,
  HARDWARE_VERSION: 0x0011,
  FIRMWARE_VERSION: 0x0012,
  FIRMWARE_BUILDS: 0x0013,
  IOCTRL_VERSION: 0x0014,
  IOCTRL_BUILD: 0x0015,
  EXP1_VERSION: 0x0016,
  EXP1_BUILD: 0x0017,
  EXP2_VERSION: 0x0018,
  EXP2_BUILD: 0x0019,
  EXPANSION_PLUS_VERSION: 0x001a,
  EXPANSION_PLUS_BUILD: 0x001b,

  FAULT_FLAGS: 0x0030,
  FAULT_FLAGS_2: 0x0031,
  AMBIENT_TEMPERATURE: 0x0032,
  MODEL: 0x0033,
  ROOF_TEMPERATURE: 54,
  POOL_TEMPERATURE: 55,
  ROOF_TEMP_LAST_PUMP_RUN: 56,
  POOL_TEMP_LAST_PUMP_RUN: 57,

  TOTAL_HOURS: 0x0040,

  SOLAR_STATE: 0x004b,
  SOLAR_INIT_TEMP: 0x004c,

  INPUTS_STATUS: 0x004d,
  OUTPUTS_STATUS: 0x004e,
  THERMISTOR_1: 0x004f,
  THERMISTOR_2: 0x0050,

  HEATER_STATE: 0x0051,

  SOLAR_WINTER_NEXT_MINS: 0x0052,
  PV_INPUT_STATE: 0x053,
  AUTO_CHLOR_STATE: 0x054,

  CHLOR_INHIBITED: 0x055,
  CHLOR_LIMIT: 0x056,

  PUMP_STATE: 92,
  PUMP_TRIGGER: 93,
  PUMP_LAST_RUN_TIME: 94,

  // 	 WIFI_SSID_START 					= 0x0064: 1,
  // 	 WIFI_SSID_END                		= ( WIFI_SSID_START+15): 1,		// (SSID max length = 32 bytes => 16 registers)

  // 	 WIFI_PASSWORD_START: 1,
  // 	 WIFI_PASSWORD_END					= ( WIFI_PASSWORD_START+31): 1,	// (Password max length = 64 bytes => 32 registers)

  WIFI_STATUS: 0x0094,
  WIFI_RSSI: 0x0095,
  WIFI_CHANNEL: 0x0096,

  // 	 AWS_CERTID_START: 1,
  // 	 AWS_CERTID_END						= ( AWS_CERTID_START+2): 1,		// (5bytes value -> 40bits => 3 registers)

  FWUPDATE_ERROR: 154,

  EXPANSION_PLUS_FWUPDATE_ERROR: 155,
  EXPANSION_PLUS_WIFI_RSSI: 156,

  SOCKET_1_STATUS: 0x00a0,
  SOCKET_2_STATUS: 0x00a1,
  SOCKET_3_STATUS: 0x00a2,
  SOCKET_4_STATUS: 0x00a3,
  SOCKET_5_STATUS: 0x00a4,
  SOCKET_6_STATUS: 0x00a5,
  SOCKET_7_STATUS: 0x00a6,
  SOCKET_8_STATUS: 0x00a7,
  VALVE_1_STATUS: 0x00a8,
  VALVE_2_STATUS: 0x00a9,
  VALVE_3_STATUS: 0x00aa,
  VALVE_4_STATUS: 0x00ab,
  VF_CONTACT_1_STATUS: 0x00ac,

  PH_MEAS: 0x00ad,
  ORP_MEAS: 0x00ae,

  ACID_PUMP_LAST_RUN_TIME: 0x00af,
  CHLORINE_PUMP_LAST_RUN_TIME: 0x00b0,

  THERMISTOR_3: 177,

  ACID_DOSING_STATUS: 178,
  CHLORINE_DOSING_STATUS: 179,

  PH_LEVEL: 180,
  ORP_LEVEL: 181,

  PH_CURR: 182,
  ORP_CURR: 183,

  HEATER_2_STATE: 184,
  VF_CONTACT_2_STATUS: 185,
  WATER_TEMPERATURE: 186,
  SPA_ON_FROM: 187,

  EXPANSION_4_FWUPDATE_ERROR_SLAVE1: 0x00bc,
  EXPANSION_4_FWUPDATE_ERROR_SLAVE2: 0x00bd,
  EXPANSION_4_WIFI_RSSI_SLAVE1: 0x00be,
  EXPANSION_4_WIFI_RSSI_SLAVE2: 0x00bf,
  SMART_HEATER_1_STATE: 0x00c0, //192
  //SMART_HEATER_2_STATE: 0x00C1,       //193
  SMART_HEATER_ERROR_BITMAP1: 0x012e,
  SMART_HEATER_ERROR_BITMAP2: 0x012f,
  SMART_HEATER_ERROR_BITMAP3: 0x0130,
  SMART_HEATER_ERROR_BITMAP4: 0x0131,
  SM_HEATER_TEMPERATURE: 0x132,

  SMART_HEATER_1_FAULTS: 0x0136, //310
  // SMART_HEATER_2_PRIMARY_PROBLEM_INDEX  = 0x0137,

  SLAVE_1_ONLINE_STATE: 0x0138,
  SLAVE_2_ONLINE_STATE: 0x0139,
  SLAVE_3_ONLINE_STATE: 0x013a,

  SLAVE_1_ONLINE_COUNT: 0x013b,
  SLAVE_2_ONLINE_COUNT: 0x013c,
  SLAVE_3_ONLINE_COUNT: 0x013d,
  EXP1_TYPE: 0x013e,
  EXP2_TYPE: 0x013f,
  CHLOR_DUTY_CYCLE_STATUS: 0x0140,
  CHLOR_DUTY_CYCLE_SECS_LEFT: 0x0141,
  SM_HEATER_OUTLET_TEMP: 0x0142,
  READ_HEAP_FREE: 0x0143,
  READ_HEAP_MIN: 0x0144,
  READ_CHLORINATOR_AMPS: 0x0145,
  READ_CHLORINATOR_VOLTS: 0x0146,
  READ_CHLORINATOR_VOLTS_2: 0x0147,
  READ_AMBIENT_TEMPERATURE: 0x0148,
  READ_ONE_WIRE_TEMPERATURE: 0x0149,
  // SMART_HEATER_2_FAULTS: 0x0137,      //311

  // 	 Last								=  SPA_ON_FROM: 1,

  // 	 MAX								= 0x0100: 1,

  // 	/* Start new write-enable register range */
  // 	 RECLAIM_BASE						= 40960: 1,	// 0xA000
  // 	 RECLAIM_First						=  RECLAIM_BASE: 1,
  // 	/* Start new write-enable register range */
  LOGGING_INTERVAL: 40993,
  LOGGING_REMOTE: 40994,

  // 	 RECLAIM_Last						=  LOGGING_REMOTE: 1,

  // 	PSW_REG_WRITE2_RECLAIM_MAX						= 45055: 1,	// 0xAFFF

  // 	/* Start new write-enable register range */
  // 	 BASE2								= 0xE000: 1,
  // 	 ENABLE2_First						=  BASE2: 1,

  APPLIANCE1_NAME_START: 0xe000,
  APPLIANCE1_NAME_2: 0xe001,
  APPLIANCE1_NAME_3: 0xe002,
  APPLIANCE1_NAME_4: 0xe003,
  APPLIANCE1_NAME_5: 0xe004,
  APPLIANCE1_NAME_6: 0xe005,
  APPLIANCE1_NAME_7: 0xe006,
  APPLIANCE1_NAME_END: 0xe007,
  APPLIANCE2_NAME_START: 0xe008,
  APPLIANCE2_NAME_2: 0xe009,
  APPLIANCE2_NAME_3: 0xe00a,
  APPLIANCE2_NAME_4: 0xe00b,
  APPLIANCE2_NAME_5: 0xe00c,
  APPLIANCE2_NAME_6: 0xe00d,
  APPLIANCE2_NAME_7: 0xe00e,
  APPLIANCE2_NAME_END: 0xe00f,

  APPLIANCE3_NAME_START: 0xe010,
  APPLIANCE3_NAME_2: 0xe011,
  APPLIANCE3_NAME_3: 0xe012,
  APPLIANCE3_NAME_4: 0xe013,
  APPLIANCE3_NAME_5: 0xe014,
  APPLIANCE3_NAME_6: 0xe015,
  APPLIANCE3_NAME_7: 0xe016,
  APPLIANCE3_NAME_END: 0xe017,
  APPLIANCE4_NAME_START: 0xe018,
  APPLIANCE4_NAME_2: 0xe019,
  APPLIANCE4_NAME_3: 0xe01a,
  APPLIANCE4_NAME_4: 0xe01b,
  APPLIANCE4_NAME_5: 0xe01c,
  APPLIANCE4_NAME_6: 0xe01d,
  APPLIANCE4_NAME_7: 0xe01e,
  APPLIANCE4_NAME_END: 0xe01f,
  APPLIANCE5_NAME_START: 0xe020,
  APPLIANCE5_NAME_2: 0xe021,
  APPLIANCE5_NAME_3: 0xe022,
  APPLIANCE5_NAME_4: 0xe023,
  APPLIANCE5_NAME_5: 0xe024,
  APPLIANCE5_NAME_6: 0xe025,
  APPLIANCE5_NAME_7: 0xe026,
  APPLIANCE5_NAME_END: 0xe027,
  APPLIANCE6_NAME_START: 0xe028,
  APPLIANCE6_NAME_2: 0xe029,
  APPLIANCE6_NAME_3: 0xe02a,
  APPLIANCE6_NAME_4: 0xe02b,
  APPLIANCE6_NAME_5: 0xe02c,
  APPLIANCE6_NAME_6: 0xe02d,
  APPLIANCE6_NAME_7: 0xe02e,
  APPLIANCE6_NAME_END: 0xe02f,
  APPLIANCE7_NAME_START: 0xe030,
  APPLIANCE7_NAME_2: 0xe031,
  APPLIANCE7_NAME_3: 0xe032,
  APPLIANCE7_NAME_4: 0xe033,
  APPLIANCE7_NAME_5: 0xe034,
  APPLIANCE7_NAME_6: 0xe035,
  APPLIANCE7_NAME_7: 0xe036,
  APPLIANCE7_NAME_END: 0xe037,

  APPLIANCE8_NAME_START: 0xe038,
  APPLIANCE8_NAME_2: 0xe039,
  APPLIANCE8_NAME_3: 0xe03a,
  APPLIANCE8_NAME_4: 0xe03b,
  APPLIANCE8_NAME_5: 0xe03c,
  APPLIANCE8_NAME_6: 0xe03d,
  APPLIANCE8_NAME_7: 0xe03e,
  APPLIANCE8_NAME_END: 0xe03f,
  APPLIANCE9_NAME_START: 0xe040,
  APPLIANCE9_NAME_2: 0xe041,
  APPLIANCE9_NAME_3: 0xe042,
  APPLIANCE9_NAME_4: 0xe043,
  APPLIANCE9_NAME_5: 0xe044,
  APPLIANCE9_NAME_6: 0xe045,
  APPLIANCE9_NAME_7: 0xe046,
  APPLIANCE9_NAME_END: 0xe047,
  APPLIANCE10_NAME_START: 0xe048,
  APPLIANCE10_NAME_2: 0xe049,
  APPLIANCE10_NAME_3: 0xe04a,
  APPLIANCE10_NAME_4: 0xe04b,
  APPLIANCE10_NAME_5: 0xe04c,
  APPLIANCE10_NAME_6: 0xe04d,
  APPLIANCE10_NAME_7: 0xe04e,
  APPLIANCE10_NAME_END: 0xe04f,
  APPLIANCE11_NAME_START: 0xe050,
  APPLIANCE11_NAME_2: 0xe051,
  APPLIANCE11_NAME_3: 0xe052,
  APPLIANCE11_NAME_4: 0xe053,
  APPLIANCE11_NAME_5: 0xe054,
  APPLIANCE11_NAME_6: 0xe055,
  APPLIANCE11_NAME_7: 0xe056,
  APPLIANCE11_NAME_END: 0xe057,
  APPLIANCE12_NAME_START: 0xe058,
  APPLIANCE12_NAME_2: 0xe059,
  APPLIANCE12_NAME_3: 0xe05a,
  APPLIANCE12_NAME_4: 0xe05b,
  APPLIANCE12_NAME_5: 0xe05c,
  APPLIANCE12_NAME_6: 0xe05d,
  APPLIANCE12_NAME_7: 0xe05e,
  APPLIANCE12_NAME_END: 0xe05f,
  APPLIANCE13_NAME_START: 0xe060,
  APPLIANCE13_NAME_2: 0xe061,
  APPLIANCE13_NAME_3: 0xe062,
  APPLIANCE13_NAME_4: 0xe063,
  APPLIANCE13_NAME_5: 0xe064,
  APPLIANCE13_NAME_6: 0xe065,
  APPLIANCE13_NAME_7: 0xe066,
  APPLIANCE13_NAME_END: 0xe067,

  SOCKET_1_LINK_INDEX: 0xe068,
  SOCKET_2_LINK_INDEX: 0xe069,
  SOCKET_3_LINK_INDEX: 0xe06a,
  SOCKET_4_LINK_INDEX: 0xe06b,
  SOCKET_5_LINK_INDEX: 0xe06c,
  SOCKET_6_LINK_INDEX: 0xe06d,
  SOCKET_7_LINK_INDEX: 0xe06e,
  SOCKET_8_LINK_INDEX: 0xe06f,
  VALVE_1_LINK_INDEX: 0xe070,
  VALVE_2_LINK_INDEX: 0xe071,
  VALVE_3_LINK_INDEX: 0xe072,
  VALVE_4_LINK_INDEX: 0xe073,
  VFCONTACT_1_LINK_INDEX: 0xe074,

  WIFI_BLE_ENABLE: 0xe075,

  APPLIANCE14_NAME_START: 0xe076,
  APPLIANCE14_NAME_2: 0xe077,
  APPLIANCE14_NAME_3: 0xe078,
  APPLIANCE14_NAME_4: 0xe079,
  APPLIANCE14_NAME_5: 0xe07a,
  APPLIANCE14_NAME_6: 0xe07b,
  APPLIANCE14_NAME_7: 0xe07c,
  APPLIANCE14_NAME_END: 0xe07d,
  APPLIANCE15_NAME_START: 0xe07e,
  APPLIANCE15_NAME_2: 0xe07f,
  APPLIANCE15_NAME_3: 0xe080,
  APPLIANCE15_NAME_4: 0xe081,
  APPLIANCE15_NAME_5: 0xe082,
  APPLIANCE15_NAME_6: 0xe083,
  APPLIANCE15_NAME_7: 0xe084,
  APPLIANCE15_NAME_END: 0xe085,
  APPLIANCE16_NAME_START: 0xe086,
  APPLIANCE16_NAME_2: 0xe087,
  APPLIANCE16_NAME_3: 0xe088,
  APPLIANCE16_NAME_4: 0xe089,
  APPLIANCE16_NAME_5: 0xe08a,
  APPLIANCE16_NAME_6: 0xe08b,
  APPLIANCE16_NAME_7: 0xe08c,
  APPLIANCE16_NAME_END: 0xe08d,
  APPLIANCE17_NAME_START: 0xe08e,
  APPLIANCE17_NAME_2: 0xe08f,
  APPLIANCE17_NAME_3: 0xe090,
  APPLIANCE17_NAME_4: 0xe091,
  APPLIANCE17_NAME_5: 0xe092,
  APPLIANCE17_NAME_6: 0xe093,
  APPLIANCE17_NAME_7: 0xe094,
  APPLIANCE17_NAME_END: 0xe095,
  APPLIANCE18_NAME_START: 0xe096,
  APPLIANCE18_NAME_2: 0xe097,
  APPLIANCE18_NAME_3: 0xe098,
  APPLIANCE18_NAME_4: 0xe099,
  APPLIANCE18_NAME_5: 0xe09a,
  APPLIANCE18_NAME_6: 0xe09b,
  APPLIANCE18_NAME_7: 0xe09c,
  APPLIANCE18_NAME_END: 0xe09d,
  APPLIANCE19_NAME_START: 0xe09e,
  APPLIANCE19_NAME_2: 0xe09f,
  APPLIANCE19_NAME_3: 0xe0a0,
  APPLIANCE19_NAME_4: 0xe0a1,
  APPLIANCE19_NAME_5: 0xe0a2,
  APPLIANCE19_NAME_6: 0xe0a3,
  APPLIANCE19_NAME_7: 0xe0a4,
  APPLIANCE19_NAME_END: 0xe0a5,

  VFCONTACT_2_TYPE: 57510,
  // 	 EXP_1_TYPE: 57511,
  // 	 EXP_2_TYPE: 57512,
  // 	 EXP_3_TYPE: 57513,
  // 	 EXP_4_TYPE: 57514,
  // 	 EXP_5_TYPE: 57515,
  // 	 EXP_6_TYPE: 57516,

  VFCONTACT_2_MODE: 57517,
  // 	 EXP_1_MODE: 57518,
  // 	 EXP_2_MODE: 57519,
  // 	 EXP_3_MODE: 57520,
  // 	 EXP_4_MODE: 57521,
  // 	 EXP_5_MODE: 57522,
  // 	 EXP_6_MODE: 57523,

  VFCONTACT_2_SETTING: 57524,
  // 	 EXP_1_SETTING: 57525,
  // 	 EXP_2_SETTING: 57526,
  // 	 EXP_3_SETTING: 57527,
  // 	 EXP_4_SETTING: 57528,
  // 	 EXP_5_SETTING: 57529,
  // 	 EXP_6_SETTING: 57530,

  VFCONTACT_2_TIME_ENABLE: 57531,
  // 	 EXP_1_TIME_ENABLE: 57532,
  // 	 EXP_2_TIME_ENABLE: 57533,
  // 	 EXP_3_TIME_ENABLE: 57534,
  // 	 EXP_4_TIME_ENABLE: 57535,
  // 	 EXP_5_TIME_ENABLE: 57536,
  // 	 EXP_6_TIME_ENABLE: 57537,

  VFCONTACT_2_TIME_1_START_TIME: 57538,
  // 	 EXP_1_TIME_1_START_TIME: 57539,
  // 	 EXP_2_TIME_1_START_TIME: 57540,
  // 	 EXP_3_TIME_1_START_TIME: 57541,
  // 	 EXP_4_TIME_1_START_TIME: 57542,
  // 	 EXP_5_TIME_1_START_TIME: 57543,
  // 	 EXP_6_TIME_1_START_TIME: 57544,

  VFCONTACT_2_TIME_1_STOP_TIME: 57545,
  // 	 EXP_1_TIME_1_STOP_TIME: 57546,
  // 	 EXP_2_TIME_1_STOP_TIME: 57547,
  // 	 EXP_3_TIME_1_STOP_TIME: 57548,
  // 	 EXP_4_TIME_1_STOP_TIME: 57549,
  // 	 EXP_5_TIME_1_STOP_TIME: 57550,
  // 	 EXP_6_TIME_1_STOP_TIME: 57551,
  VFCONTACT_2_TIME_2_START_TIME: 57552,
  // 	 EXP_1_TIME_2_START_TIME: 57553,
  // 	 EXP_2_TIME_2_START_TIME: 57554,
  // 	 EXP_3_TIME_2_START_TIME: 57555,
  // 	 EXP_4_TIME_2_START_TIME: 57556,
  // 	 EXP_5_TIME_2_START_TIME: 57557,
  // 	 EXP_6_TIME_2_START_TIME: 57558,
  VFCONTACT_2_TIME_2_STOP_TIME: 57559,
  // 	 EXP_1_TIME_2_STOP_TIME: 57560,
  // 	 EXP_2_TIME_2_STOP_TIME: 57561,
  // 	 EXP_3_TIME_2_STOP_TIME: 57562,
  // 	 EXP_4_TIME_2_STOP_TIME: 57563,
  // 	 EXP_5_TIME_2_STOP_TIME: 57564,
  // 	 EXP_6_TIME_2_STOP_TIME: 57565,

  HEAT_PUMP_2_ENABLE: 57566,
  GAS_HEATER_2_ENABLE: 57567,
  GAS_HEAT2_COOL_DOWN_TIME: 57568,
  CHILL_2_FUNCTION: 57569,
  HEAT_DEM_2_SANITISER_EN: 57570,
  HEAT_2_SPEED: 57571,
  HEATER_2_SOLAR_PRIORITY: 57572,
  HEATER_2_ROOFTEMP_CUTOFF: 57573,
  HEATER_2_PUMP_TYPE: 57574,
  POOL_2_SET_TEMPERATURE: 57575,
  SPA_2_SET_TEMPERATURE: 57576,
  RUN_TILL_HEATED_2_FUNC: 57577,
  HEATER_2_TRACKING_ENABLE: 57578,
  HEATER_2_TRACKING_OFFSET: 57579,
  THERMISTOR_3_TYPE: 57580,
  THERMISTOR_3_OFFSET: 57581,
  HEATER_USES_WATER: 57582,
  HEATER_2_USES_WATER: 57583,
  SOLAR_RUN_FROM_HEATER_PUMP: 57584,

  HEATER_EXPANSION_PRESENT: 57585,
  HEATER_HYDROTHERAPY_MODE: 57586,
  HEATER_2_HYDROTHERAPY_MODE: 57587,
  ANTIFREEZE_ACTIVE: 57588,
  ANTIFREEZE_TEMPERATURE: 57589,

  POOL_NAME_START: 57590,
  POOL_NAME_2: 57591,
  POOL_NAME_3: 57592,
  POOL_NAME_4: 57593,
  POOL_NAME_5: 57594,
  POOL_NAME_6: 57595,
  POOL_NAME_7: 57596,
  POOL_NAME_END: 57597,

  SPA_NAME_START: 57598,
  SPA_NAME_2: 57599,
  SPA_NAME_3: 57600,
  SPA_NAME_4: 57601,
  SPA_NAME_5: 57602,
  SPA_NAME_6: 57603,
  SPA_NAME_7: 57604,
  SPA_NAME_END: 57605,

  SPA_TIMER_2_ENABLE: 57606,
  SPA_TIMER_2_START_TIME: 57607,
  SPA_TIMER_2_STOP_TIME: 57608,

  SOLAR_USES_WATER: 57609,

  LIGHT_1_REINIT: 57610,
  LIGHT_2_REINIT: 57611,
  LIGHT_3_REINIT: 57612,

  // 	/* new run once enabled*/
  SOCKET_1_RUN_ONCE_ENABLE: 57613,
  SOCKET_2_RUN_ONCE_ENABLE: 57614,
  SOCKET_3_RUN_ONCE_ENABLE: 57615,
  SOCKET_4_RUN_ONCE_ENABLE: 57616,
  SOCKET_5_RUN_ONCE_ENABLE: 57617,
  SOCKET_6_RUN_ONCE_ENABLE: 57618,
  SOCKET_7_RUN_ONCE_ENABLE: 57619,
  SOCKET_8_RUN_ONCE_ENABLE: 57620,
  VALVE_1_RUN_ONCE_ENABLE: 57621,
  VALVE_2_RUN_ONCE_ENABLE: 57622,
  VALVE_3_RUN_ONCE_ENABLE: 57623,
  VALVE_4_RUN_ONCE_ENABLE: 57624,
  VFCONTACT_1_RUN_ONCE_ENABLE: 57625,
  VFCONTACT_2_RUN_ONCE_ENABLE: 57626,
  EXP_2_RUN_ONCE_ENABLE: 57627,
  EXP_3_RUN_ONCE_ENABLE: 57628,
  EXP_4_RUN_ONCE_ENABLE: 57629,
  FILTER_RUN_ONCE_ENABLE: 57630,
  SOLAR_RUN_ONCE_ENABLE: 57631,
  SPA_RUN_ONCE_ENABLE: 57632,
  SOCKET_1_RUN_ONCE_START_TIME: 57633,
  SOCKET_2_RUN_ONCE_START_TIME: 57634,
  SOCKET_3_RUN_ONCE_START_TIME: 57635,
  SOCKET_4_RUN_ONCE_START_TIME: 57636,
  SOCKET_5_RUN_ONCE_START_TIME: 57637,
  SOCKET_6_RUN_ONCE_START_TIME: 57638,
  SOCKET_7_RUN_ONCE_START_TIME: 57639,
  SOCKET_8_RUN_ONCE_START_TIME: 57640,
  VALVE_1_RUN_ONCE_START_TIME: 57641,
  VALVE_2_RUN_ONCE_START_TIME: 57642,
  VALVE_3_RUN_ONCE_START_TIME: 57643,
  VALVE_4_RUN_ONCE_START_TIME: 57644,
  VFCONTACT_1_RUN_ONCE_START_TIME: 57645,
  VFCONTACT_2_RUN_ONCE_START_TIME: 57646,
  EXP_2_RUN_ONCE_START_TIME: 57647,
  EXP_3_RUN_ONCE_START_TIME: 57648,
  EXP_4_RUN_ONCE_START_TIME: 57649,
  FILTER_RUN_ONCE_START_TIME: 57650,
  SOLAR_RUN_ONCE_START_TIME: 57651,
  SPA_RUN_ONCE_START_TIME: 57652,

  SOCKET_1_RUN_ONCE_STOP_TIME: 57653,
  SOCKET_2_RUN_ONCE_STOP_TIME: 57654,
  SOCKET_3_RUN_ONCE_STOP_TIME: 57655,
  SOCKET_4_RUN_ONCE_STOP_TIME: 57656,
  SOCKET_5_RUN_ONCE_STOP_TIME: 57657,
  SOCKET_6_RUN_ONCE_STOP_TIME: 57658,
  SOCKET_7_RUN_ONCE_STOP_TIME: 57659,
  SOCKET_8_RUN_ONCE_STOP_TIME: 57660,
  VALVE_1_RUN_ONCE_STOP_TIME: 57661,
  VALVE_2_RUN_ONCE_STOP_TIME: 57662,
  VALVE_3_RUN_ONCE_STOP_TIME: 57663,
  VALVE_4_RUN_ONCE_STOP_TIME: 57664,
  VFCONTACT_1_RUN_ONCE_STOP_TIME: 57665,
  VFCONTACT_2_RUN_ONCE_STOP_TIME: 57666,
  EXP_2_RUN_ONCE_STOP_TIME: 57667,
  EXP_3_RUN_ONCE_STOP_TIME: 57668,
  EXP_4_RUN_ONCE_STOP_TIME: 57669,
  FILTER_RUN_ONCE_STOP_TIME: 57670,
  SOLAR_RUN_ONCE_STOP_TIME: 57671,
  SPA_RUN_ONCE_STOP_TIME: 57672,

  BLOWER_TIMEOUT_ENABLED: 57673,
  SOLAR_FORCE_RUN_ON: 57674,
  SOLAR_TURN_ON_DIFFERENCE: 57675,
  SOLAR_TURN_OFF_DIFFERENCE: 57676,
  MODEL_LABEL: 57677,
  PUMP_CALL_DEBOUNCE: 57678,
  ACID_DOSE_DAILY_LIMIT: 57679,
  CHLOR_DOSE_DAILY_LIMIT: 57680,
  CHLOR_DUTY_CYCLE: 57681,
  LOGGING_DISABLE_REGS: 57682,
  // 	 ENABLE2_Last						= 0xFEFF: 1,
  // 	/* End new write-enable register range */

  FWUPDATE: 0xff00,

  // SWC board firmware upgrades. Each board (Power, IO) has a main and a
  // backup firmware slot, each with its own command register plus a matching
  // error register.
  FWUPDATE_POWER_BOARD_MAIN: 61440, // 0xF000
  FWUPDATE_POWER_BOARD_BACKUP: 61441, // 0xF001
  FWUPDATE_IO_BOARD_MAIN: 61442, // 0xF002
  FWUPDATE_IO_BOARD_BACKUP: 61443, // 0xF003
  FWUPDATE_POWER_BOARD_MAIN_ERROR: 400,
  FWUPDATE_POWER_BOARD_BACKUP_ERROR: 401,
  FWUPDATE_IO_BOARD_MAIN_ERROR: 402,
  FWUPDATE_IO_BOARD_BACKUP_ERROR: 403,

  // BASE3								=
  FWUPDATE_EXP4_SLAVE1: 0xfe00,
  // PRIVATE2_First				    = FWUPDATE_EXP4_SLAVE1,
  FWUPDATE_EXP4_SLAVE2: 0xfe01,
  SMART_HEATER_FUNCTION: 0xfe02,
  HEATER_1_USES_SH_SENS: 0xfe03,
  HEATER_2_USES_SH_SENS: 0xfe04,
  HEATER_1_MOVE_ON: 0xfe05,
  HEATER_2_MOVE_ON: 0xfe06,
  EXP4_SLAVE1_TYPE: 0xfe07,
  THERMISTOR_4_OFFSET: 0xfe08,
  // EXP4_SLAVE2_TYPE:                 0xFE08,
  EXPANSION4_PRESENT: 0xfe09,
  // PRIVATE2_Last						= 0xFEFF,

  // 	 PRIVATE_First
  RESET_OPTIONS: 0xff01,
  ENABLE_UUID: 0xff02,
  OTA_AUTH: 0xff03,
  OTA_HTTPS_ONLY: 0xff04,
  LCD_CONTRAST: 0xff05,
  TEST_OUTPUT: 0xff06,
  TEST_420MA: 0xff07,
  TEST_DISPLAY: 0xff08,
  DEVICE_PASSCODE: 0xff09,
  LOGGING_ENABLE: 0xff0a,
  FILTER_TIMEn_ENABLE: 0xff0b,
  FWUPDATE_EXPANSION_PLUS: 0xff0c,
  SET_MODEL: 0xff0d,
  BOOTUP_COUNT: 0xff0e,
  RESTART_COUNT: 0xff0f,
  // PRIVATE_Last

  RTC_YEAR: 65296,
  RTC_MONTH: 65297,
  RTC_DAY: 65298,
  RTC_HOUR: 65299,
  RTC_MIN: 65300,

  TIMEZONE: 65301,
  AUTO_SET_TIME: 65302,
  LOCATION: 65303,
  ADJUST_DST: 65304,
  RTC_SEC: 65305,

  OPERATING_MODE: 65312,
  SPA_MODE: 65313,

  THERMISTOR_1_TYPE: 65314,
  THERMISTOR_2_TYPE: 65315,
  THERMISTOR_1_OFFSET: 65316,
  THERMISTOR_2_OFFSET: 65317,

  FILTER_TIME_ENABLE: 65318,
  FILTER_TIME_1_START_TIME: 65319,
  FILTER_TIME_1_STOP_TIME: 65320,
  FILTER_TIME_2_START_TIME: 65321,
  FILTER_TIME_2_STOP_TIME: 65322,

  SOCKET_1_TYPE: 65323,
  SOCKET_2_TYPE: 65324,
  SOCKET_3_TYPE: 65325,
  SOCKET_4_TYPE: 65326,
  SOCKET_5_TYPE: 65327,
  SOCKET_6_TYPE: 65328,
  SOCKET_7_TYPE: 65329,
  SOCKET_8_TYPE: 65330,
  VALVE_1_TYPE: 65331,
  VALVE_2_TYPE: 65332,
  VALVE_3_TYPE: 65333,
  VALVE_4_TYPE: 65334,
  VFCONTACT_1_TYPE: 65335,

  SOCKET_1_MODE: 65336,
  SOCKET_2_MODE: 65337,
  SOCKET_3_MODE: 65338,
  SOCKET_4_MODE: 65339,
  SOCKET_5_MODE: 65340,
  SOCKET_6_MODE: 65341,
  SOCKET_7_MODE: 65342,
  SOCKET_8_MODE: 65343,
  VALVE_1_MODE: 65344,
  VALVE_2_MODE: 65345,
  VALVE_3_MODE: 65346,
  VALVE_4_MODE: 65347,
  VFCONTACT_1_MODE: 65348,

  SOCKET_1_SETTING: 65349,
  SOCKET_2_SETTING: 65350,
  SOCKET_3_SETTING: 65351,
  SOCKET_4_SETTING: 65352,
  SOCKET_5_SETTING: 65353,
  SOCKET_6_SETTING: 65354,
  SOCKET_7_SETTING: 65355,
  SOCKET_8_SETTING: 65356,
  VALVE_1_SETTING: 65357,
  VALVE_2_SETTING: 65358,
  VALVE_3_SETTING: 65359,
  VALVE_4_SETTING: 65360,
  VFCONTACT_1_SETTING: 65361,

  SOCKET_1_TIME_ENABLE: 65362,
  SOCKET_2_TIME_ENABLE: 65363,
  SOCKET_3_TIME_ENABLE: 65364,
  SOCKET_4_TIME_ENABLE: 65365,
  SOCKET_5_TIME_ENABLE: 65366,
  SOCKET_6_TIME_ENABLE: 65367,
  SOCKET_7_TIME_ENABLE: 65368,
  SOCKET_8_TIME_ENABLE: 65369,
  VALVE_1_TIME_ENABLE: 65370,
  VALVE_2_TIME_ENABLE: 65371,
  VALVE_3_TIME_ENABLE: 65372,
  VALVE_4_TIME_ENABLE: 65373,
  VFCONTACT_1_TIME_ENABLE: 65374,

  SOCKET_1_TIME_1_START_TIME: 65375,
  SOCKET_2_TIME_1_START_TIME: 65376,
  SOCKET_3_TIME_1_START_TIME: 65377,
  SOCKET_4_TIME_1_START_TIME: 65378,
  SOCKET_5_TIME_1_START_TIME: 65379,
  SOCKET_6_TIME_1_START_TIME: 65380,
  SOCKET_7_TIME_1_START_TIME: 65381,
  SOCKET_8_TIME_1_START_TIME: 65382,
  VALVE_1_TIME_1_START_TIME: 65383,
  VALVE_2_TIME_1_START_TIME: 65384,
  VALVE_3_TIME_1_START_TIME: 65385,
  VALVE_4_TIME_1_START_TIME: 65386,
  VFCONTACT_1_TIME_1_START_TIME: 65387,

  SOCKET_1_TIME_1_STOP_TIME: 65388,
  SOCKET_2_TIME_1_STOP_TIME: 65389,
  SOCKET_3_TIME_1_STOP_TIME: 65390,
  SOCKET_4_TIME_1_STOP_TIME: 65391,
  SOCKET_5_TIME_1_STOP_TIME: 65392,
  SOCKET_6_TIME_1_STOP_TIME: 65393,
  SOCKET_7_TIME_1_STOP_TIME: 65394,
  SOCKET_8_TIME_1_STOP_TIME: 65395,
  VALVE_1_TIME_1_STOP_TIME: 65396,
  VALVE_2_TIME_1_STOP_TIME: 65397,
  VALVE_3_TIME_1_STOP_TIME: 65398,
  VALVE_4_TIME_1_STOP_TIME: 65399,
  VFCONTACT_1_TIME_1_STOP_TIME: 65400,

  SOCKET_1_TIME_2_START_TIME: 65401,
  SOCKET_2_TIME_2_START_TIME: 65402,
  SOCKET_3_TIME_2_START_TIME: 65403,
  SOCKET_4_TIME_2_START_TIME: 65404,
  SOCKET_5_TIME_2_START_TIME: 65405,
  SOCKET_6_TIME_2_START_TIME: 65406,
  SOCKET_7_TIME_2_START_TIME: 65407,
  SOCKET_8_TIME_2_START_TIME: 65408,
  VALVE_1_TIME_2_START_TIME: 65409,
  VALVE_2_TIME_2_START_TIME: 65410,
  VALVE_3_TIME_2_START_TIME: 65411,
  VALVE_4_TIME_2_START_TIME: 65412,
  VFCONTACT_1_TIME_2_START_TIME: 65413,

  SOCKET_1_TIME_2_STOP_TIME: 65414,
  SOCKET_2_TIME_2_STOP_TIME: 65415,
  SOCKET_3_TIME_2_STOP_TIME: 65416,
  SOCKET_4_TIME_2_STOP_TIME: 65417,
  SOCKET_5_TIME_2_STOP_TIME: 65418,
  SOCKET_6_TIME_2_STOP_TIME: 65419,
  SOCKET_7_TIME_2_STOP_TIME: 65420,
  SOCKET_8_TIME_2_STOP_TIME: 65421,
  VALVE_1_TIME_2_STOP_TIME: 65422,
  VALVE_2_TIME_2_STOP_TIME: 65423,
  VALVE_3_TIME_2_STOP_TIME: 65424,
  VALVE_4_TIME_2_STOP_TIME: 65425,
  VFCONTACT_1_TIME_2_STOP_TIME: 65426,

  LIGHTS_1_SYNC: 65427,
  LIGHTS_2_SYNC: 65428,

  PUMP_ENABLE: 65429,
  PUMP_SPEED_TYPE: 65430,
  PUMP_MODEL: 65431,
  PUMP_SPEED_1: 65432,
  PUMP_SPEED_2: 65433,
  PUMP_SPEED_3: 65434,
  PUMP_SPEED_4: 65435,

  SOLAR_MODE: 65436,
  SOLAR_TYPE: 65437,
  SOLAR_SET_TEMPERATURE: 65438,
  SOLAR_SPEED: 65439,
  SOLAR_START_TIME: 65440,

  SPA_SET_TEMPERATURE: 65441,
  SPA_BLOWER_ENABLE: 65442,
  SPA_LIMIT_OFFSET: 65443,
  SPA_CHLORINATOR_ENABLE: 65444,
  SPA_CHLORINATOR_DUTY_CYCLE: 65445,
  SPA_LIGHT: 65446,

  POOL_SET_TEMPERATURE: 65447,
  PUMP_CALL_ENABLE: 65448,
  HEAT_PUMP_ENABLE: 65449,
  GAS_HEATER_ENABLE: 65450,
  GAS_HEATER_COOL_DOWN_TIME: 65451,

  WATER_FEATURE_TYPE: 65452,

  SLAVE_1_ENABLE: 65453,
  SLAVE_2_ENABLE: 65454,
  SLAVE_1_ADDRESS: 65455,
  SLAVE_2_ADDRESS: 65456,
  RESET_EXPANSIONS: 65457,
  SCAN_EXPANSIONS: 65458,
  SPA_SPEED: 65459,
  SPA_JETPUMP_ENABLE: 65460,

  WATER_FEATURE_SPEED: 65461,
  HEATING_SPEED: 65462,
  PUMP_DEFAULT_SPEED: 65463,
  PUMP_VSP_MODE: 65464,
  HEAT_DEMAND_ENABLE: 65465,
  HEAT_DEMAND_START_TIME: 65466,
  HEAT_DEMAND_STOP_TIME: 65467,

  LIGHTS_3_SYNC: 65468,
  FILTER_TIME_3_START_TIME: 65469,
  FILTER_TIME_3_STOP_TIME: 65470,
  FILTER_TIME_4_START_TIME: 65471,
  FILTER_TIME_4_STOP_TIME: 65472,

  FILTER_TIME_1_SPEED: 65473,
  FILTER_TIME_2_SPEED: 65474,
  FILTER_TIME_3_SPEED: 65475,
  FILTER_TIME_4_SPEED: 65476,

  HEATING_PUMP_CALL_SPEED: 65477,
  PUMP_SPEED_PERCENTAGE_1: 65478,
  PUMP_SPEED_PERCENTAGE_2: 65479,
  PUMP_SPEED_PERCENTAGE_3: 65480,
  PUMP_SPEED_PERCENTAGE_4: 65481,

  SPA_ENABLE: 65482,

  PUMP_MANUAL_ON_TIME: 65483,
  PUMP_MANUAL_OFF_TIME: 65484,
  PUMP_MANUAL_ON_OFF: 65485,

  SPA_LIMIT_OFFSET_ENABLE: 65486,

  INSTALLER_MENU_CODE: 65487,

  DEVICE_NAME_START: 65488,
  DEVICE_NAME_2: 65489,
  DEVICE_NAME_3: 65490,
  DEVICE_NAME_4: 65491,
  DEVICE_NAME_5: 65492,
  DEVICE_NAME_6: 65493,
  DEVICE_NAME_7: 65494,
  DEVICE_NAME_END: 65495,

  SOLAR_END_TIME: 65496,
  SPA_SLEEP_TIMER: 65497,
  SOLAR_SENSOR_LOCATION: 65498,
  HEATING_PUMP_TYPE: 65499,
  RUN_TILL_HEATED_FUNC: 65500,
  HEAT_DEM_SANITISER_EN: 65501,

  ORP_SET_POINT: 65502,
  PH_SET_POINT: 65503,
  SLAVE_3_ENABLE: 65504,
  SOLAR_WINTER_MODE: 65505,
  HEATER_ROOFTEMP_CUTOFF: 65506,
  HEATER_SOLAR_PRIORITY: 65507,
  PH_SENSOR_CONNECTED: 65508,
  ORP_SENSOR_CONNECTED: 65509,

  POOL_SIZE: 65510,
  SPA_SIZE: 65511,

  OVERRIDE_SENSOR_SETTLING: 65512,

  PH_SENSOR_OFFSET: 65513,
  ORP_SENSOR_OFFSET: 65514,

  DOSING_OPTION: 65515,
  PRIME_DOSING_PUMP: 65516,

  SPA_TIMER_ENABLE: 65517,
  SPA_TIMER_START_TIME: 65518,
  SPA_TIMER_STOP_TIME: 65519,

  PH_SET_POINT_INSTALLER: 65520,
  ORP_SET_POINT_INSTALLER: 65521,

  LIGHTS_LINKED: 65522,

  HEATER_CHILL_FUNC: 65523,
  PUMP_CALL_RUN_ON_TIME: 65524,
  PUMP_CALL_ENABLED_ITEMS: 65525,
  PUMP_PRIME_DISABLE: 65526,
};
